import React, { useState } from 'react';
import './Blog.css';
import { 
  FaCalendarAlt, 
  FaShareAlt, 
  FaCommentAlt, 
  FaHeart, 
  FaRegHeart, 
  FaBookmark, 
  FaRegBookmark,
  FaUtensils,
  FaPepperHot,
  FaLeaf,
  FaIceCream
} from 'react-icons/fa';
import { FiArrowRight } from 'react-icons/fi';
import { GiIndiaGate, GiMeal, GiCook } from 'react-icons/gi';
import { BiDish } from 'react-icons/bi';

const blogPosts = [
  {
    id: 1,
    title: "5 Must-Try Dishes at papadam",
    date: "June 18, 2025",
    summary: "Explore the top Indian delicacies our chefs recommend for your first visit! From our signature butter chicken to the aromatic biryanis, discover what makes these dishes special.",
    image: "https://images.unsplash.com/photo-1559847844-5315695dadae?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    video: "https://www.youtube.com/embed/8L1Z-THwQd4",
    category: "Food Guide",
    tags: ["Dishes", "Recommendations", "Popular"],
    comments: 12,
    shares: 45,
    likes: 128,
    readTime: "4 min read",
    author: {
      name: "Chef Priya Sharma",
      avatar: "https://randomuser.me/api/portraits/women/42.jpg",
      bio: "Head Chef with 15 years experience in North Indian cuisine"
    },
    fullContent: `<p>When you visit papadam for the first time, the menu can be overwhelming with its array of authentic Indian dishes. Here are our top 5 recommendations that showcase the diversity and richness of Indian cuisine:</p>
    <h3>1. Butter Chicken</h3>
    <p>Our signature dish features tender chicken pieces cooked in a creamy tomato-based gravy with aromatic spices. The secret is in our 24-hour marinade process.</p>
    <h3>2. Lamb Biryani</h3>
    <p>Fragrant basmati rice layered with succulent lamb pieces and slow-cooked with saffron and spices. Served with raita and boiled egg.</p>
    <h3>3. Paneer Tikka</h3>
    <p>Marinated cottage cheese cubes grilled in our traditional tandoor, served with mint chutney. A perfect vegetarian starter.</p>
    <h3>4. Dal Makhani</h3>
    <p>Black lentils slow-cooked overnight with butter and cream, finished with a touch of smokiness from our charcoal technique.</p>
    <h3>5. Gulab Jamun</h3>
    <p>Soft milk-solid dumplings soaked in rose-scented syrup, served warm with vanilla ice cream.</p>
    <p>Each of these dishes represents a different aspect of Indian culinary tradition, from the rich curries of Punjab to the delicate desserts of Bengal.</p>`
  },
  {
    id: 2,
    title: "Why Tandoori is a Crowd Favorite",
    date: "June 12, 2025",
    summary: "Tandoori flavors are more than just spicy — they're artfully balanced and rich. Our head chef explains the centuries-old techniques we use to perfect our tandoori dishes.",
    image: "https://images.unsplash.com/photo-1601050690597-df0568f70950?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    category: "Cooking Secrets",
    tags: ["Tandoor", "Techniques", "History"],
    comments: 8,
    shares: 32,
    likes: 95,
    readTime: "6 min read",
    author: {
      name: "Chef Raj Patel",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
      bio: "Master of tandoor cooking with expertise in Northwest frontier cuisine"
    },
    fullContent: `<p>The tandoor oven has been central to Indian cooking for centuries, and at papadam, we maintain these traditions while adding our modern touches.</p>
    <h3>The Tandoor Difference</h3>
    <p>Our clay tandoor reaches temperatures of 900°F (480°C), cooking food quickly while sealing in juices. The radiant heat and live flames create the characteristic char and smoky flavor.</p>
    <h3>Our Signature Marinades</h3>
    <p>We use a base of yogurt and spices, but the magic is in:</p>
    <ul>
      <li>24-hour marination for all meats</li>
      <li>Freshly ground spice blends</li>
      <li>A touch of raw papaya for tenderizing</li>
      <li>Mustard oil for authentic flavor</li>
    </ul>
    <h3>Tandoor Favorites</h3>
    <div class="image-grid">
      <img src="https://images.unsplash.com/photo-1602253057119-44d745d9b860" alt="Tandoori Chicken">
      <img src="https://images.unsplash.com/photo-1632818924360-68d4994cfdb2" alt="Tandoori Roti">
      <img src="https://images.unsplash.com/photo-1601050690117-94f5f6fa3bd0" alt="Tandoori Platter">
    </div>
    <p>From our classic chicken tikka to innovative paneer skewers, the tandoor brings out flavors no conventional oven can match.</p>`
  },
  {
    id: 3,
    title: "A Peek Into Our Kitchen",
    date: "June 5, 2025",
    summary: "Ever wondered what happens behind the scenes? Let us take you inside the making of our meals. See how our chefs prepare 200+ dishes daily with authentic techniques.",
    image: "https://images.unsplash.com/photo-1556911220-bff31c812dba?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    video: "https://www.youtube.com/embed/7IY2WtBn3d0",
    category: "Behind the Scenes",
    tags: ["Kitchen", "Chefs", "Process"],
    comments: 15,
    shares: 67,
    likes: 210,
    readTime: "8 min read",
    author: {
      name: "Manager Deepak Kumar",
      avatar: "https://randomuser.me/api/portraits/men/45.jpg",
      bio: "Restaurant manager with 10 years experience in fine dining"
    },
    fullContent: `<p>Our kitchen operates like a well-oiled machine, with each station dedicated to specific cooking methods. Here's how we prepare 200+ dishes daily without compromising quality.</p>
    <h3>Morning Prep (6-10 AM)</h3>
    <p>The day begins with:</p>
    <ul>
      <li>Fresh vegetable delivery and washing</li>
      <li>Meat butchering and marination</li>
      <li>Dough preparation for breads</li>
      <li>Spice blending for the day's dishes</li>
    </ul>
    <h3>Lunch Service (11 AM-3 PM)</h3>
    <p>Our busiest time with:</p>
    <ul>
      <li>12 chefs working simultaneously</li>
      <li>3 tandoor ovens at full capacity</li>
      <li>Curry station preparing 15 different sauces</li>
    </ul>
    <h3>Evening Transition (3-5 PM)</h3>
    <p>We:</p>
    <ul>
      <li>Restock all stations</li>
      <li>Prepare dinner specials</li>
      <li>Clean and sanitize all surfaces</li>
    </ul>
    <h3>Dinner Service (5-10 PM)</h3>
    <p>Our premium service features:</p>
    <ul>
      <li>Chef's tasting menu</li>
      <li>Live cooking demonstrations</li>
      <li>Special dessert preparations</li>
    </ul>`
  },
  
];

const Blog = () => {
  const [likedPosts, setLikedPosts] = useState([]);
  const [savedPosts, setSavedPosts] = useState([]);
  const [activeCategory, setActiveCategory] = useState('All');
  const [email, setEmail] = useState('');
  const [expandedPost, setExpandedPost] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const toggleLike = (postId) => {
    if (likedPosts.includes(postId)) {
      setLikedPosts(likedPosts.filter(id => id !== postId));
    } else {
      setLikedPosts([...likedPosts, postId]);
    }
  };

  const toggleSave = (postId) => {
    if (savedPosts.includes(postId)) {
      setSavedPosts(savedPosts.filter(id => id !== postId));
    } else {
      setSavedPosts([...savedPosts, postId]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Thanks for subscribing with ${email}! You'll receive our next update soon.`);
    setEmail('');
  };

  const categories = ['All', ...new Set(blogPosts.map(post => post.category))];
  
  const filteredPosts = activeCategory === 'All' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === activeCategory);

  const searchedPosts = searchTerm 
    ? filteredPosts.filter(post => 
        post.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
        post.summary.toLowerCase().includes(searchTerm.toLowerCase()) ||
        post.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase())))
    : filteredPosts;

  const expandPost = (postId) => {
    setExpandedPost(expandedPost === postId ? null : postId);
  };

  const featuredPost = blogPosts[0];

  return (
    <div className="blog-container">
      {/* Hero Header */}
      {/* <div className="blog-header">
        <div className="header-content">
          <h1>Papadam <span>Blog</span></h1>
          <p className="subtitle">Stories, recipes, and culinary insights from our kitchen to your table</p>
          <div className="header-decoration">
            <div className="spice-dots">
              {[...Array(5)].map((_, i) => <div key={i} className="spice-dot"></div>)}
            </div>
          </div>
        </div>
      </div> */}

      {/* Search and Category Filter */}
      <div className="blog-controls">
        {/* <div className="search-box">
          <input 
            type="text" 
            placeholder="Search posts..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button className="search-btn">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
          </button>
        </div> */}
        
        {/* <div className="category-filter">
          {categories.map(category => (
            <button
              key={category}
              className={`category-btn ${activeCategory === category ? 'active' : ''}`}
              onClick={() => setActiveCategory(category)}
            >
              {category === 'Food Guide' && <FaUtensils />}
              {category === 'Cooking Secrets' && <GiCook />}
              {category === 'Behind the Scenes' && <BiDish />}
              {category === 'Culture' && <GiIndiaGate />}
              {category === 'Vegetarian' && <FaLeaf />}
              {category === 'Breads' && <GiMeal />}
              {category}
            </button>
          ))}
        </div> */}
      </div>

      {/* Featured Post */}
      {!searchTerm && (
        <div className="featured-post">
          <div className="featured-media">
            <img src={featuredPost.image} alt={featuredPost.title} />
            <div className="featured-badge">Featured Story</div>
            <div className="media-overlay"></div>
          </div>
          <div className="featured-content">
            <div className="post-category">{featuredPost.category}</div>
            <h2>{featuredPost.title}</h2>
            <p className="post-summary">{featuredPost.summary}</p>
            <div className="post-meta">
              <div className="author-info">
                <img src={featuredPost.author.avatar} alt={featuredPost.author.name} />
                <div>
                  <span className='authorname'>{featuredPost.author.name}</span>
                  <small>{featuredPost.author.bio}</small>
                </div>
              </div>
              <div className="meta-stats">
                <span><FaCalendarAlt /> {featuredPost.date}</span>
                <span>{featuredPost.readTime}</span>
                <span><FaCommentAlt /> {featuredPost.comments}</span>
                <span><FaShareAlt /> {featuredPost.shares}</span>
                <span>{featuredPost.likes} <FaHeart /></span>
              </div>
            </div>
            <button className="read-more-btn" onClick={() => expandPost(featuredPost.id)}>
              {expandedPost === featuredPost.id ? 'Show Less' : 'Read Full Story'} <FiArrowRight />
            </button>
            
            {expandedPost === featuredPost.id && (
              <div className="post-full-content" dangerouslySetInnerHTML={{ __html: featuredPost.fullContent }} />
            )}
          </div>
        </div>
      )}

      {/* Blog Posts Grid */}
      <div className="blog-posts">
        {searchedPosts.length > 0 ? (
          searchedPosts.map((post) => (
            <article key={post.id} className="blog-post">
              <div className="post-category">{post.category}</div>
              
              <div className="post-media">
                {post.video ? (
                  <div className="video-container">
                    <iframe 
                      src={post.video} 
                      frameBorder="0" 
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                      allowFullScreen
                      title={post.title}
                    ></iframe>
                  </div>
                ) : (
                  <img src={post.image} alt={post.title} />
                )}
                <div className="post-actions">
                  <button 
                    className={`like-btn ${likedPosts.includes(post.id) ? 'liked' : ''}`} 
                    onClick={() => toggleLike(post.id)}
                    aria-label={likedPosts.includes(post.id) ? "Unlike post" : "Like post"}
                  >
                    {likedPosts.includes(post.id) ? <FaHeart /> : <FaRegHeart />}
                    <span>{post.likes + (likedPosts.includes(post.id) ? 1 : 0)}</span>
                  </button>
                  <button 
                    className={`save-btn ${savedPosts.includes(post.id) ? 'saved' : ''}`} 
                    onClick={() => toggleSave(post.id)}
                    aria-label={savedPosts.includes(post.id) ? "Unsave post" : "Save post"}
                  >
                    {savedPosts.includes(post.id) ? <FaBookmark /> : <FaRegBookmark />}
                  </button>
                </div>
              </div>
              
              <div className="post-content">
                <h2>{post.title}</h2>
                <p className="post-summary">{post.summary}</p>
                
                <div className="post-tags">
                  {post.tags.map(tag => (
                    <span key={tag} className="tag">{tag}</span>
                  ))}
                </div>
                
                <div className="post-meta">
                  <div className="author-info">
                    <img src={post.author.avatar} alt={post.author.name} />
                    <div>
                      <span className='authorname'>{post.author.name}</span>
                      <small>{post.author.bio}</small>
                    </div>
                  </div>
                  <div className="meta-stats">
                    <span><FaCalendarAlt /> {post.date}</span>
                    <span>{post.readTime}</span>
                    <span><FaCommentAlt /> {post.comments}</span>
                    <span><FaShareAlt /> {post.shares}</span>
                  </div>
                </div>
                
                <button className="read-more-btn" onClick={() => expandPost(post.id)}>
                  {expandedPost === post.id ? 'Show Less' : 'Continue Reading'} <FiArrowRight />
                </button>
                
                {expandedPost === post.id && (
                  <div className="post-full-content" dangerouslySetInnerHTML={{ __html: post.fullContent }} />
                )}
              </div>
            </article>
          ))
        ) : (
          <div className="no-results">
            <h3>No posts found matching your search</h3>
            <p>Try a different search term or browse our categories</p>
          </div>
        )}
      </div>


      {/* Instagram Feed */}
      <div className="instagram-feed">
        <h4>Follow Us @papadamRestaurant</h4>
        <div className="instagram-posts">
          {[
            "https://images.unsplash.com/photo-1565557623262-b51c2513a641",
            "https://images.unsplash.com/photo-1544025162-d76694265947",
            "https://images.unsplash.com/photo-1559847844-5315695dadae",
            "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38",
            "https://images.unsplash.com/photo-1565958011703-44f9829ba187",
            "https://images.unsplash.com/photo-1482049016688-2d3e1b311543"
          ].map((img, index) => (
            <div key={index} className="insta-post">
              <img src={`${img}?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80`} alt={`Instagram post ${index + 1}`} />
              <div className="insta-overlay">
                <FaHeart /> 245
                <FaCommentAlt /> 32
              </div>
            </div>
          ))}
        </div>
      </div>


    </div>
  );
};

export default Blog;